/** How an attached document should be previewed inline, inferred from its
 *  filename extension. Pure + exported so the mapping is unit-tested and
 *  shared by any surface that renders an invoice (detail page, flashcard,
 *  portal). */
export type PreviewKind = 'image' | 'pdf' | 'other';

const IMAGE_EXTENSIONS: ReadonlySet<string> = new Set([
  'png',
  'jpg',
  'jpeg',
  'gif',
  'webp',
  'bmp',
  'avif',
  'svg',
]);

export function previewKindForFilename(filename: string | null | undefined): PreviewKind {
  if (!filename) return 'other';
  const dot = filename.lastIndexOf('.');
  if (dot === -1 || dot === filename.length - 1) return 'other';
  const ext = filename.slice(dot + 1).toLowerCase();
  if (ext === 'pdf') return 'pdf';
  if (IMAGE_EXTENSIONS.has(ext)) return 'image';
  return 'other';
}

/** The presigned URL to preview with: the one bundled into the
 *  transaction-documents response (no extra round-trip) when present, else
 *  the one from the separate `invoice-download` query. `null` until either
 *  resolves. Pure so the bundled-vs-fallback precedence is unit-tested. */
export function resolvePreviewUrl(
  bundledUrl: string | null | undefined,
  fallbackUrl: string | null | undefined,
): string | null {
  return bundledUrl ?? fallbackUrl ?? null;
}
